<template>
    <v-dialog v-model="dialog" max-width="650" >
        <v-card class="standard-row dialog-create-doc-card">
            <v-row no-gutters class="standard-row" style="padding: 29px 4% 5px 4%;">
                <v-col cols="12" sm="auto" md="auto" lg="auto"
                    class="pr-sm-3 font-theme font-size-header-confirm-create set-center-document-modal">
                    {{ getTitle() }}
                </v-col>
                <v-col cols="12" sm="auto" md="auto" lg="auto" class="pr-sm-3 set-center-document-modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-envelope-check" viewBox="0 0 16 16">
                        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"/>
                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"/>
                    </svg>
                </v-col>
                
            </v-row>
            <v-row class="standard-row" style="padding: 0 4%;">
                    <v-textarea v-if="this.action !== 'OpenDialog' && this.action !== 'RunPo'" v-model="comment_Doc" hide-details outlined class="py-0 font-theme border-radius-box text-area-description" color="black" style="background-color: rgba(217, 217, 217, 0.44);"></v-textarea>
                    <v-textarea v-else v-model="comment_detail" readonly hide-details outlined class="py-0 font-theme border-radius-box text-area-description" color="black" style="background-color: rgba(217, 217, 217, 0.44);"></v-textarea>  
            </v-row>
            <v-row class="standard-row text-center d-flex justify-center create-document-row">
                <div v-if="this.action !== 'OpenDialog'" class="mr-3" style="padding-top: 10px;">
                    <v-btn v-if="this.action === 'CancelDoc'" @click="confirmCancel_cs_to_po(id)" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text mr-2" style="width: 71px; height: 30px;">
                        ยืนยัน
                    </v-btn>
                    <v-btn v-if="this.action === 'Rejected'" @click="confirmCancel_cs_to_po(id)" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text mr-2" style="width: 71px; height: 30px;">
                        ยืนยัน
                    </v-btn>
                    <v-btn v-if="this.action === 'RunPo'" @click="confirmCancel_cs_to_po(id)" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text mr-2" style="width: 71px; height: 30px;">
                        ยืนยัน
                    </v-btn>
                    <v-btn @click="closeDialog()" color="#E0E0E0"
                        class="elevation-0 font-theme confirm-btn white--text ml-2" style="width: 71px; height: 30px;">
                        ยกเลิก
                    </v-btn>
                </div>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
export default {
    data() {
        return {
            windowSize: { x: 0 },
            dialog: false,
            action: '',
            id:'',
            comment_Doc:'',
            comment_detail:'',
        };
    },
    mounted() {
        this.onResize()
        // EventBus.$on('call-RunPo', (action,_id,formData) => {
        //     this.action= action 
        //     this.id = _id 
        //     this.formData = formData
        //     this.confirmCancel_cs_to_po(this.id)
        //     });
    },
    beforeDestroy() {
        // EventBus.$off('call-RunPo');
    },
    watch: {
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        }
    },
    computed:{
       
    },
    created() {
        EventBus.$on('openDialog', (comment_detail) => {
        this.comment_detail = comment_detail
        });
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        open(action,_id,formData) { 
            this.action = action;
            if (this.action === 'RunPo') {
                this.id = _id;
                this.formData = formData
                this.confirmCancel_cs_to_po(this.id)
            } else {
                this.id = _id;
                this.formData = formData
                this.dialog = true;
            }
        },
        navigateToWaitQT() {
            // Navigate to the '/create_wait_qt' path
            this.$router.push({ path: '/create_cspo_wait_qt' });
        },
        closeDialog() {
            // ทำสิ่งที่คุณต้องการเมื่อ Confirm Dialog ถูกปิด
            console.log('Confirm Dialog closed!');
            this.dialog = false;
            // อาจจะเรียก method หรือทำอื่นๆ ที่คุณต้องการ
        },
        getTitle() {
            if (this.action === 'CancelDoc') {
                return 'โปรดระบุเหตุผลในการยกเลิก';
            }else if (this.action === 'OpenDialog') {
                return 'เหตุผลในการปฏิเสธ';
            }else if (this.action === 'RunPo') {
                return 'RUNPO';
            } else  {
                return 'โปรดระบุเหตุผลในการปฎิเสธ';
            }
        },

        async confirmCancel_cs_to_po(id) {
            this.loadingState = true
                if (this.action === 'CancelDoc') {
                    this.document_status = 'C';
                    } else if (this.action === 'Rejected') {
                    this.document_status = 'R';
                    }else{
                    this.document_status = 'N';
                    }                    
                const temp_body = {
                    "vendor_code":  this.formData?.Vendor_code || null,
                    "name":  this.formData?.Vendor_name || null,
                    "job_no":  this.formData?.Job_no || null,  
                    "date":  this.formData?.Date || null,
                    // "document_type_id":  this.formData?.Document_type_id || null,
                    "document_type_name":  this.formData?.Document_Types || null,
                    "address":  this.formData?.Address || null,
                    "qt_no":  this.formData?.Qt_no || null,
                    "purchase_group":  this.formData?.Purchase_Groups || null,
                    "procurement":  this.formData?.Procurement_Methods || null,
                    "telephone":  this.formData?.Telephone || null,
                    "start_date":  this.formData?.Start_date || null,
                    "end_date" :  this.formData?.End_date || null,
                    "due_date":  this.formData?.Due_date || null,
                    "reason":  this.formData?.Purchase_Reasons || null,
                    "type_budget":  this.formData?.Budget_Categories || null,
                    "email":  this.formData?.Email || null,
                    "credit_term":  this.formData?.Credit_Term || null,
                    "po_type":  this.formData?.PO_Types || null,
                    "org_code":  this.formData?.Organization_Codes || null,
                    "note":  this.formData?.Note_items || null,
                    "vat":this.formData?.Vat || null,
                    "total_discount":this.formData?.Total_discount|| null,
                    "total_products_price": this.formData?.Total_products_price|| null,
                    "lead_time_delivery" :this.formData?.Lead_time_delivery || null,
                    "total_price": this.formData?.Total_price || null ,
                    "item_detail": this.formData?.Item_detail || null,
                    "document_status": this.document_status || null,
                    "comment": this.comment_Doc || null,
                    "vat_condition":  this.formData?.Vat_items || null,
                    "total_dif": this.formData?.total_dif || null,
                    "period":  this.formData?.Period || null,
                    "payment_plan":  this.formData?.payment_plan || null,
                    "grand_total": this.formData?.payment_plan.grand_total || null,
                    "item_list": this.formData?.list || null,
                    "sale_name": this.formData?.Sale_Name || null,
                    "payment_plan_type" : this.formData?.payment_plan_type || null
                }; 
                try {
                    const { data } = await this.axios.put(`${this.$api_url}/cs_to_po/api/v1/update_run_po/${id || ''}`, temp_body)
                    if (data.status) {
                        this.dialog = false; 
                        if(this.action === 'CancelDoc') {
                            this.alert('ยกเลิกรายการที่บันทึกสำเร็จ', 'Success', 'success');
                        } else if (this.action === 'Rejected') {
                            this.alert('ปฎิเสธรายการที่บันทึกสำเร็จ', 'Success', 'success');
                        }else{
                            this.alert('รายการที่บันทึกสำเร็จ', 'Success', 'success');
                        }
                        EventBus.$emit('call-get-inbox-detail'); 
                    } else {
                        if(data.message === 'qt vendor is duplicated') {
                            this.alert('บันทึกไม่สำเร็จ Qt Vendor ซ้ำในระบบ', 'Fail', 'error'); 
                        } else if(data.message === 'docment deleted') {
                            this.alert('บันทึกไม่สำเร็จ ไม่พบเอกสารในระบบหรือมีการยกเลิกแล้ว', 'Fail', 'error');
                        } else if(data.message === 'document updated') {
                                this.alert('บันทึกไม่สำเร็จ เอกสารมีการอัปเดตแล้ว', 'Fail', 'error');
                        } else if(data.message === 'update permission denined') {
                                this.alert('บันทึกไม่สำเร็จ ไม่มีสิทธิ์อัปเดตเอกสาร', 'Fail', 'error');
                        }
                        else this.alert('รายการที่บันทึกไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                        console.log(error)
                        this.alert('รายการที่บันทึกไม่สำเร็จ', 'Fail', 'error')
                } finally { this.loadingState = false }  
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            },
    },
}
</script>
<style>
    .scroll-create-purchase-modal {
        max-height: calc(100vh - 254px);
        min-height: 254px !important;
        overflow-y: auto;
        border-radius: 20px !important;
    }
</style>